import { RootState } from 'shared/store/store'

export const getAvailableCases = (state: RootState) =>
  state.communication.inbox.cases

export const getInboxMarkedLabels = (state: RootState) =>
  state.communication.inbox.markedLabels

export const getRemoveLabelQueue = (state: RootState) =>
  state.communication.inbox.removeLabelsQueue

export const getMessageForCase = (state: RootState) =>
  state.communication.inbox.messageForCase
